import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';

type Props = {} & InjectedIntlProps;

class PageNotFound extends React.Component<Props> {
    public render() {
        const { intl } = this.props;
        return (
            <div className="center full-screen gray-bg">
                <div className="center animated fadeIn">
                    <div id="center-dialog" className="widget yellow-bg p-lg text-center">
                        <div className="m-b-md">
                            <i className="fa fa-frog fa-4x"/>
                            <h1 className="m-xs">{intl.formatMessage({ id: 'page.pageNotFound.title' })}</h1>
                            <h3 className="font-bold no-margins">{intl.formatMessage({ id: 'page.pageNotFound.subTitle' })}</h3>
                        </div>
                        <small>{intl.formatMessage({ id: 'page.pageNotFound.message' })}</small>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(PageNotFound);



// WEBPACK FOOTER //
// ./src/pages/PageNotFound/PageNotFound.tsx